

import React, { useState, useEffect } from "react";
import { ChevronDown, Car, Shield, Clock, Star, Phone, Mail, MapPin, User, Award, MessageCircle } from "lucide-react";
import styles from "./Home.module.css";

function Home() {

  const features = [
    { icon: <Car className={styles.featureIcon} />, title: "Premium Vehicles", description: "Modern, comfortable cars maintained to the highest standards" },
    { icon: <Shield className={styles.featureIcon} />, title: "Safe & Secure", description: "Fully licensed drivers with excellent safety records" },
    { icon: <Clock className={styles.featureIcon} />, title: "Always On Time", description: "Punctual service that respects your schedule" }
  ];

  const drivers = [
    { 
      name: "Fady Mohsen", 
      experience: "8 years", 
      languages: "Arabic, English", 
      specialty: "City Tours & Airport Transfers", 
      image: "👨‍💼",  
    }
  ];

  return (
    <div className={styles.container}>
      {/* Hero Section */}
      <section className={styles.hero}>
        <div className={styles.heroBackground}>
          <div className={styles.heroOverlay}></div>
          <div className={styles.floatingElement1}></div>
          <div className={styles.floatingElement2}></div>
          <div className={styles.floatingElement3}></div>
        </div>
        <div className={styles.heroContent}>
          <div className={styles.heroText}>
            <h1 className={styles.heroTitle}>
              <span className={styles.heroTitleGradient}>Mariam Tours</span>
            </h1>
            <p className={styles.heroSubtitle}>
              Experience luxury travel with our premium private car tours. Professional drivers,
              comfortable journeys, and unforgettable memories await.
            </p>
            <div className={styles.heroButtons}>
              <a href="/contact" className={styles.primaryButton}>
                <span className={styles.buttonText}>Book Your Journey</span>
                <div className={styles.buttonOverlay}></div>
              </a>
              <a href="/drivers" className={styles.secondaryButton}>
                Meet Our Drivers
              </a>
            </div>
          </div>
        </div>
        <div className={styles.scrollIndicator}>
          <ChevronDown className={styles.scrollIcon} />
        </div>
      </section>

      {/* Decorative Divider */}
      {/* <div className={styles.decorativeDivider}></div> */}

      {/* Features */}
      <section className={styles.features}>
        <div className={styles.container}>
          <div className={styles.sectionHeader}>
            <h2 className={styles.sectionTitle}>Why Choose Mariam Tours?</h2>
            <p className={styles.sectionSubtitle}>
              We deliver exceptional service that goes beyond transportation
            </p>
          </div>
          <div className={styles.featuresGrid}>
            {features.map((feature, i) => (
              <div key={i} className={styles.featureCard}>
                <div className={styles.featureIconContainer}>{feature.icon}</div>
                <h3 className={styles.featureTitle}>{feature.title}</h3>
                <p className={styles.featureDescription}>{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Gradient Fade Divider */}
      {/* <div className={styles.gradientFade}></div> */}

      {/* Drivers Preview */}
      <section className={styles.drivers}>
        <div className={styles.container}>
          <div className={styles.sectionHeader}>
            <h2 className={styles.sectionTitle}>Meet Our Professional Drivers</h2>
            <p className={styles.sectionSubtitle}>
              Experienced, licensed, and dedicated to making your journey exceptional
            </p>
          </div>
          <div className={styles.driversGrid}>
            {drivers.map((driver, i) => (
              <div key={i} className={styles.driverCard}>
                <div className={styles.driverContent}>
                  <div className={styles.driverAvatar}>{driver.image}</div>
                  <h3 className={styles.driverName}>{driver.name}</h3>
                  <div className={styles.driverDetails}>
                    <div className={styles.driverDetail}>
                      <Award className={styles.detailIcon} />
                      <span className={styles.detailText}>{driver.experience} experience</span>
                    </div>
                    <div className={styles.driverDetail}>
                      <User className={styles.detailIcon} />
                      <span className={styles.detailText}>{driver.languages}</span>
                    </div>
                    <div className={styles.driverDetail}>
                      <Car className={styles.detailIcon} />
                      <span className={styles.detailText}>{driver.specialty}</span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div className={styles.sectionFooter}>
            <div className={styles.buttonContainer}>
              <a href="/drivers" className={styles.primaryButton}>See All Drivers</a>
            </div>
          </div>
        </div>
      </section>

      {/* Gradient Fade Divider */}
      {/* <div className={styles.gradientFade}></div> */}

                  {/* Cars Poster Section */}
      <section className={styles.cars}>
        <div className={styles.container}>
          <div className={styles.sectionHeader}>
            <h2 className={styles.sectionTitle}>Our Cars</h2>
            <p className={styles.sectionSubtitle}>
              Take a look at our luxury fleet available for tours
            </p>
          </div>
          <div className={styles.carsPoster}>
            <img 
              src="/cars/combinedCars.png" 
              alt="Our Cars" 
              className={styles.carsImage} 
            />
          </div>
        </div>
      </section>


            {/* Simple Line */}
      {/* <div className={styles.sectionDivider}></div> */}

      {/* Contact Preview */}
      <section className={styles.contact}>
        <div className={styles.container}>
          <div className={styles.contactHeader}>
            <h2 className={styles.contactTitle}>Ready for Your Next Adventure?</h2>
            <p className={styles.contactSubtitle}>
              Book your private tour today and experience the difference of premium travel service
            </p>
          </div>
          <div className={styles.contactCardsGrid}>
            <div className={styles.contactCard}>
              <Phone className={styles.contactIcon} />
              <h3 className={styles.contactCardTitle}>Call Us</h3>
              <p className={styles.contactCardText}>+20 110 462 5154</p>
            </div>
            <div className={styles.contactCard}>
              <MessageCircle className={styles.contactIcon} />
              <h3 className={styles.contactCardTitle}>WhatsApp</h3>
              <p className={styles.contactCardText}>+20 127 494 8282</p>
            </div>
          </div>
          <div className={styles.sectionFooter}>
            <div className={styles.buttonContainer}>
              <a href="/contact" className={styles.primaryButton}>Go to Contact Page</a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Home;
